import { BreakpointValue, breakpoints } from '@utils/breakpoints'
import { ReactNode } from 'react'
import { ClientGate } from './client-gate'
import { useBreakpoint } from '@hooks/breakpoints'

type BreakpointProps = {
  val: BreakpointValue
  max?: boolean
  children: ReactNode
}

type BreakpointBarrelComponent = React.FC<BreakpointProps> & {
  XXS: React.FC<Omit<BreakpointProps, 'val'>>
  XS: React.FC<Omit<BreakpointProps, 'val'>>
  SM: React.FC<Omit<BreakpointProps, 'val'>>
  MD: React.FC<Omit<BreakpointProps, 'val'>>
  LG: React.FC<Omit<BreakpointProps, 'val'>>
  XL: React.FC<Omit<BreakpointProps, 'val'>>
  XXL: React.FC<Omit<BreakpointProps, 'val'>>
}

function _Breakpoint({ val, max = false, children }: BreakpointProps) {
  const active = useBreakpoint(val, { max })
  if (!active) return null
  return <ClientGate>{children}</ClientGate>
}

function XXS({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.xxs}>
      {children}
    </_Breakpoint>
  )
}

function XS({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.xs}>
      {children}
    </_Breakpoint>
  )
}

function SM({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.sm}>
      {children}
    </_Breakpoint>
  )
}

function MD({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.md}>
      {children}
    </_Breakpoint>
  )
}

function LG({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.lg}>
      {children}
    </_Breakpoint>
  )
}

function XL({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.xl}>
      {children}
    </_Breakpoint>
  )
}

function XXL({ max, children }: Omit<BreakpointProps, 'val'>) {
  return (
    <_Breakpoint max={max} val={breakpoints.xxl}>
      {children}
    </_Breakpoint>
  )
}

export const Breakpoint: BreakpointBarrelComponent = Object.assign(
  _Breakpoint,
  {
    XXS,
    XS,
    SM,
    MD,
    LG,
    XL,
    XXL,
  }
)
